const _excluded = ["scale"],
  _excluded2 = ["x"];
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { AxisBottom, AxisLeft } from "@visx/axis";
import { Line } from "@visx/shape";
import { observer } from "mobx-react";
import { memo, useEffect, useRef } from "react";
import LineAndPointChart from "./LineAndPointChart";
import LineChart from "./LineChart";
import MomentLinesChart from "./MomentLinesChart";
import MomentPointsChart from "./MomentPointsChart";
import PointOnMap from "./PointOnMap";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const LABEL_COLOR = "#efefef";
const Y_AXIS_NUM_TICKS = 4;
const Y_AXIS_TICK_LABEL_FONT_SIZE = 10;
export const Plot = /*#__PURE__*/memo(_ref => {
  let {
    chartItems,
    initialScales,
    zoomedScales
  } = _ref;
  const chartRefs = useRef([]);
  useEffect(() => {
    var _chartRefs$current;
    (_chartRefs$current = chartRefs.current) === null || _chartRefs$current === void 0 || _chartRefs$current.forEach((ref, i) => {
      if (typeof (ref === null || ref === void 0 ? void 0 : ref.zoomHandle.doZoom) === "function") {
        ref.zoomHandle.doZoom(zoomedScales[i]);
      }
    });
  }, [zoomedScales]);
  const addToRefs = (id, el) => {
    if (el) {
      chartRefs.current.push({
        id,
        zoomHandle: el
      });
    } else {
      chartRefs.current = chartRefs.current.filter(ref => ref.id !== id);
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: chartItems.map((chartItem, i) => {
      const id = sanitizeIdString(chartItem.key);
      switch (chartItem.type) {
        case "line":
          return /*#__PURE__*/_jsx(LineChart, {
            ref: node => addToRefs(id, node),
            id: id,
            chartItem: chartItem,
            scales: initialScales[i]
          }, chartItem.key);
        case "momentPoints":
          {
            // Find a basis item to stick the points on, if we can't find one, we
            // vertically center the points
            const basisItemIndex = chartItems.findIndex(item => (item.type === "line" || item.type === "lineAndPoint") && item.xAxis.scale === "time");
            return /*#__PURE__*/_jsx(MomentPointsChart, {
              ref: node => addToRefs(id, node),
              id: id,
              chartItem: chartItem,
              scales: initialScales[i],
              basisItem: chartItems[basisItemIndex],
              basisItemScales: initialScales[basisItemIndex],
              glyph: chartItem.glyphStyle
            }, chartItem.key);
          }
        case "momentLines":
          {
            return /*#__PURE__*/_jsx(MomentLinesChart, {
              ref: node => addToRefs(id, node),
              id: id,
              chartItem: chartItem,
              scales: initialScales[i]
            }, chartItem.key);
          }
        case "lineAndPoint":
          {
            return /*#__PURE__*/_jsx(LineAndPointChart, {
              ref: node => addToRefs(id, node),
              id: id,
              chartItem: chartItem,
              scales: initialScales[i],
              glyph: chartItem.glyphStyle
            }, chartItem.key);
          }
      }
    })
  });
});
Plot.displayName = "Plot";
export const XAxis = /*#__PURE__*/memo(_ref2 => {
  let {
      scale
    } = _ref2,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsx(AxisBottom, _objectSpread({
    stroke: "#efefef",
    tickStroke: "#efefef",
    tickLabelProps: () => ({
      fill: "#efefef",
      textAnchor: "middle",
      fontSize: 12,
      fontFamily: "Arial"
    }),
    labelProps: {
      fill: LABEL_COLOR,
      fontSize: 12,
      textAnchor: "middle",
      fontFamily: "Arial"
    }
    // .nice() rounds the scale so that the aprox beginning and
    // aprox end labels are shown
    // See: https://stackoverflow.com/questions/21753126/d3-js-starting-and-ending-tick
    ,
    scale: scale.nice()
  }, restProps));
});
XAxis.displayName = "XAxis";
export const YAxis = /*#__PURE__*/memo(_ref3 => {
  let {
    scale,
    color,
    units,
    offset
  } = _ref3;
  return /*#__PURE__*/_jsx(AxisLeft, {
    left: offset,
    scale: scale,
    numTicks: Y_AXIS_NUM_TICKS,
    stroke: color,
    tickStroke: color,
    label: units || "",
    labelOffset: 10,
    labelProps: {
      fill: color,
      textAnchor: "middle",
      fontSize: 12,
      fontFamily: "Arial"
    },
    tickLabelProps: () => ({
      fill: color,
      textAnchor: "end",
      fontSize: Y_AXIS_TICK_LABEL_FONT_SIZE,
      fontFamily: "Arial"
    })
  }, "y-axis-".concat(units));
});
YAxis.displayName = "YAxis";
export const Cursor = /*#__PURE__*/memo(_ref4 => {
  let {
      x
    } = _ref4,
    restProps = _objectWithoutProperties(_ref4, _excluded2);
  return /*#__PURE__*/_jsx(Line, _objectSpread({
    from: {
      x,
      y: 0
    },
    to: {
      x,
      y: 1000
    }
  }, restProps));
});
Cursor.displayName = "Cursor";
export const PointsOnMap = observer(_ref5 => {
  let {
    chartItems
  } = _ref5;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: chartItems.map(chartItem => chartItem.pointOnMap && /*#__PURE__*/_jsx(PointOnMap, {
      color: chartItem.getColor(),
      point: chartItem.pointOnMap
    }, "point-on-map-".concat(chartItem.key)))
  });
});
PointsOnMap.displayName = "PointsOnMap";
const sanitizeIdString = id => {
  // delete all non-alphanum chars
  return id.replace(/[^a-zA-Z0-9_-]/g, "");
};